export const proposalTranslations = {
  en: {
    travelProposal: "Travel Proposal",
    proposalFor: "Proposal for",
    destination: "Destination",
    travelDates: "Travel Dates",
    passengers: "Passengers",
    adults: "Adults",
    children: "Children",
    infants: "Infants",
    address: "Address",
    stayOverview: "Where you'll be staying",
    flightOverview: "Flight details paired with airport services",
    dailyPlan: "Daily Plan",
    dailyPlanDescription: "Everything organized by day for a smooth journey",
    servicesLabel: "services",
    showDetails: "Show details",
    hideDetails: "Hide",
    totalOfSelectedItemsThisDay: "Total of selected items this day",
    locationMap: "View on the map",
    reviews: "reviews",
    occupancy: "Occupancy",
    roomHighlights: "Highlights",
    stayHelpTitle: "Need help with your stay?",
    stayHelpSubtitle: "Contact your travel specialist anytime.",
    includedServicesCta: "Included services",
    to: "to",
    noDate: "Date to be defined",
    
    flights: "Flights",
    transfers: "Transfers",
    services: "Services",
    tours: "Tours",
    attractions: "Attractions",
    accommodation: "Accommodation",
    airportServices: "Airport Services",
    additionalServices: "Additional Services",
    additionalRequests: "Additional Requests",
    insurance: "Insurance",
    standaloneAirportServices: "Standalone airport services",
    agencyContact: "HighClass contact",
    clientName: "Client",
    company: "Company",
    phone: "Phone",
    acceptDescription: "Click below to finalize this tailor-made trip",
    insuranceDescription: "Coverage selected for this trip",
    
    departure: "Departure",
    arrival: "Arrival",
    flightNumber: "Flight",
    airline: "Airline",
    class: "Class",
    
    transfer: "Transfer",
    date: "Date",
    type: "Type",
    
    time: "Time",
    duration: "Duration",
    hours: "hours",
    description: "Description",
    
    price: "Price",
    perPerson: "per person",
    perGroup: "per group",
    perFamily: "per family",
    included: "Included",
    optional: "Optional",
    freeOfCharge: "Free of Charge",
    subtotal: "Subtotal",
    totalTaxes: "Taxes",
    handlingFee: "Handling Fee",
    total: "Total",
    toBeQuoted: "To be quoted",
    bookingWithUs: "Booking With Us",
    nightRateComparison: "Night Rate Comparison",
    hcteNightRate: "HCTE Night Rate",
    accommodationWebsiteNightRate: "Accommodation Website Night Rate",
    bookingComNightRate: "Booking.com Night Rate",
    cancellationPolicy: "Cancellation Policy",
    flightBookingPrice: "Flight Booking Price",
    
    checkIn: "Check-in",
    checkOut: "Check-out",
    nights: "nights",
    rooms: "rooms",
    mealPlan: "Meal Plan",
    
    acceptProposal: "Accept Proposal",
    proposalConfirmed: "Proposal Confirmed!",
    confirmProposal: "Confirm Proposal",
    
    termsAndConditions: "Terms and Conditions",
    additionalInfoTitle: "Additional Information",
    generalTermsTitle: "General Terms",
    clickToView: "Click to view",
    paymentTermsTitle: "Payment Terms",
    paymentInfoHint: "Payment methods and conditions",
    
    day: "Day",
    
    priceSummary: "Price Summary",
    
    contactInformation: "Contact Information",
    contactDescription: "We're here to help you with your travel arrangements",
    supportTeamTitle: "HighClass Support Team",
    supportTeamDescription: "Contact us for questions, adjustments, or any assistance related to your proposal.",
    whatsappCta: "Talk to a consultant",
    websiteLabel: "Website",
    
    readyToConfirm: "Ready to Confirm Your Journey?",
    confirmationDescription: "By accepting this proposal, you confirm your interest and our team will reach out to finalize the details.",
    thankYouMessage: "Thank you for confirming this proposal. Our team will be in touch shortly to finalize your travel arrangements.",
    acceptTermsLabel: "I have read and agree with the terms and conditions.",
    acceptTermsRequiredError: "You must accept the terms and conditions before confirming the proposal.",
    summaryDescription: "Complete breakdown of your travel package",

    previewVersions: "Preview proposal versions",
    previewVersionsDescription: "Switch languages to validate copy and layout for each version.",
    originalLanguage: "Original language",
    previewing: "Previewing",
    show: "Show",
    hide: "Hide",
    showMore: "Show more",
    showLess: "Show less",
    noAirportServicesForFlight: "No airport services for this flight",
    
    issueDate: "Issue Date",
    expiryDate: "Expiry Date",
    createdOn: "Created on",
    expiresInPrefix: "Expires in",
    expired: "Expired",
    proposalCanceledBadge: "Proposal canceled",
    proposalCanceledTitle: "This proposal has been canceled",
    proposalCanceledContactPrompt: "Contact HighClass to continue your travel planning.",
  },
  pt_br: {
    travelProposal: "Proposta de Viagem",
    proposalFor: "Proposta para",
    destination: "Destino",
    travelDates: "Datas da Viagem",
    passengers: "Passageiros",
    adults: "Adultos",
    children: "Crianças",
    infants: "Bebês",
    address: "Endereço",
    stayOverview: "Onde você irá se hospedar",
    flightOverview: "Detalhes de voo com serviços de aeroporto",
    dailyPlan: "Roteiro Diário",
    dailyPlanDescription: "Tudo organizado por dia para uma viagem tranquila",
    servicesLabel: "serviços",
    showDetails: "Ver detalhes",
    hideDetails: "Ocultar",
    totalOfSelectedItemsThisDay: "Total dos itens selecionados no dia",
    locationMap: "Ver no mapa",
    reviews: "avaliações",
    occupancy: "Ocupação",
    roomHighlights: "Destaques",
    stayHelpTitle: "Precisa de ajuda com a hospedagem?",
    stayHelpSubtitle: "Fale com seu especialista de viagens a qualquer momento.",
    includedServicesCta: "Serviços inclusos",
    to: "até",
    noDate: "Data a definir",
    
    flights: "Voos",
    transfers: "Transfers",
    services: "Serviços",
    tours: "Passeios",
    attractions: "Atrações",
    accommodation: "Acomodação",
    airportServices: "Serviços de Aeroporto",
    additionalServices: "Serviços Adicionais",
    additionalRequests: "Solicitações Adicionais",
    insurance: "Seguro",
    standaloneAirportServices: "Serviços de aeroporto sem voo", 
    agencyContact: "Contato HighClass",
    clientName: "Cliente",
    company: "Empresa",
    phone: "Telefone",
    acceptDescription: "Clique abaixo para finalizar esta viagem sob medida",
    insuranceDescription: "Cobertura selecionada para esta viagem",
    
    departure: "Partida",
    arrival: "Chegada",
    flightNumber: "Voo",
    airline: "Companhia",
    class: "Classe",
    
    transfer: "Transfer",
    date: "Data",
    type: "Tipo",
    
    time: "Horário",
    duration: "Duração",
    hours: "horas",
    description: "Descrição",
    
    price: "Preço",
    perPerson: "por pessoa",
    perGroup: "por grupo",
    perFamily: "por família",
    included: "Incluído",
    optional: "Opcional",
    freeOfCharge: "Cortesia",
    subtotal: "Subtotal",
    totalTaxes: "Impostos",
    handlingFee: "Taxa de Serviço",
    total: "Total",
    toBeQuoted: "A ser cotado",
    bookingWithUs: "Reserva Conosco",
    nightRateComparison: "Comparativo de Tarifas por Noite",
    hcteNightRate: "Tarifa HCTE por Noite",
    accommodationWebsiteNightRate: "Tarifa no Site da Acomodação por Noite",
    bookingComNightRate: "Tarifa Booking.com por Noite",
    cancellationPolicy: "Política de cancelamento",
    flightBookingPrice: "Valor do voo conosco",
    
    checkIn: "Check-in",
    checkOut: "Check-out",
    nights: "noites",
    rooms: "quartos",
    mealPlan: "Plano de Refeições",
    
    acceptProposal: "Aceitar Proposta",
    proposalConfirmed: "Proposta Confirmada!",
    confirmProposal: "Confirmar Proposta",

    termsAndConditions: "Termos e Condições",
    additionalInfoTitle: "Informações Adicionais",
    generalTermsTitle: "Termos Gerais",
    clickToView: "Clique para visualizar",
    paymentTermsTitle: "Termos de Pagamento",
    paymentInfoHint: "Formas e condições de pagamento",
    
    day: "Dia",
    
    priceSummary: "Resumo de Preços",
    
    contactInformation: "Informações de Contato",
    contactDescription: "Estamos aqui para ajudá-lo com seus planos de viagem",
    supportTeamTitle: "Equipe HighClass de Suporte",
    supportTeamDescription: "Entre em contato conosco para dúvidas, ajustes ou qualquer assistência relacionada à sua proposta.",
    whatsappCta: "Falar com um consultor",
    websiteLabel: "Website",
    
    readyToConfirm: "Pronto para Confirmar sua Viagem?",
    confirmationDescription: "Ao aceitar esta proposta, você confirma seu interesse e nossa equipe entrará em contato para finalizar os detalhes.",
    thankYouMessage: "Obrigado por confirmar esta proposta. Nossa equipe entrará em contato em breve para finalizar seus planos de viagem.",
    acceptTermsLabel: "Li e concordo com os termos e condições.",
    acceptTermsRequiredError: "Você precisa aceitar os termos e condições antes de confirmar a proposta.",
    summaryDescription: "Detalhamento completo do seu pacote de viagem",

    previewVersions: "Visualizar versões da proposta",
    previewVersionsDescription: "Alterne os idiomas para validar o texto e o layout de cada versão.",
    originalLanguage: "Idioma original",
    previewing: "Visualizando",
    show: "Mostrar",
    hide: "Ocultar",
    showMore: "Mostrar mais",
    showLess: "Mostrar menos",
    noAirportServicesForFlight: "Sem serviços de aeroporto para este voo",
    
    issueDate: "Data de Emissão",
    expiryDate: "Data de Validade",
    createdOn: "Criada em",
    expiresInPrefix: "Expira em",
    expired: "Expirada",
    proposalCanceledBadge: "Proposta cancelada",
    proposalCanceledTitle: "Esta proposta foi cancelada",
    proposalCanceledContactPrompt: "Entre em contato com a HighClass para continuar o planejamento da sua viagem.",
  },
};

export type ProposalLanguage = keyof typeof proposalTranslations;
export type ProposalTranslations = typeof proposalTranslations.en;

export const getTranslation = (language: ProposalLanguage = 'en'): ProposalTranslations => {
  return proposalTranslations[language] || proposalTranslations.en;
};
